import { useEffect } from 'react';

import { syncEngine } from '../features/sync/engine';
import { dateKey } from '../lib/dateKey';

// Polls dateKey() every minute and notifies the sync engine when the
// local-midnight rollover happens, so a long-running PWA tab doesn't
// stay subscribed to yesterday's progress filter. Also ticks on
// visibilitychange so a phone returning from sleep catches up
// immediately without waiting for the next interval. The engine's
// onDayChanged is a no-op when the engine isn't running.
export function useDateKeyWatcher(): void {
  useEffect(() => {
    let current = dateKey();
    const tick = () => {
      const next = dateKey();
      if (next !== current) {
        current = next;
        syncEngine.onDayChanged(next);
      }
    };
    const id = setInterval(tick, 60_000);
    const onVis = () => {
      if (document.visibilityState === 'visible') tick();
    };
    document.addEventListener('visibilitychange', onVis);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, []);
}
